import { Text, TextProps } from '@components/text';
import { getScopedTranslate } from '@locale/translate';

import { ACTION_TYPE } from 'api/types';

export type ActionLabelProps = Omit<TextProps, 'text' | 'children'> & {
  action: ACTION_TYPE;
};

export const ActionLabel = ({ action, ...rest }: ActionLabelProps) => {
  const label = actionLabels[action];

  if (!label) {
    console.error(`Unable to find label for action: ${action}`);
    return null;
  }

  return <Text font="regular12" {...rest} text={label} />;
};

const { t } = getScopedTranslate({
  en: {
    ask_ai: 'Ask AI',
    ask_ai_agent: 'Ask AI Agent',
    code: 'Code',
    combo_send_form: 'Send form',
    condition: 'Condition',
    condition_v2: 'Condition',
    convert_document: 'Convert document',
    create_document: 'Create document',
    calendar_event: 'Calendar event',
    ghost: 'Ghost',
    branch_base: 'Branch base',
    integration: 'Integration',
    webhook: 'Webhook',
    journey_branch: 'Branch',
    journey_merge: 'Wait for other actions',
    journey_start: 'Start',
    journey_triggers: 'Triggers',
    placeholder: 'Placeholder',
    formatter: 'Formatter',
    send_email: 'Send email',
    send_sms: 'Send SMS',
    journey_loop: 'Journey Loop',
    break_loop: 'Exit Loop',
    wait_for_time: 'Wait for #',
    wait_for_attribute_change: 'Wait for field change',
    wait_until_fixed_date: 'Wait until # date',
    wait_until_relative_date: 'Wait until # date',
    update_fields: 'Journey fields',
    add_to_journey: 'Add traveller to journey',
    update_traveller: 'Traveller fields',
    hidden: 'Hidden',
    instantiate_form: 'Instantiate form',
    anonymize_text: 'Anonymize text',
    extract_text: 'Extract text',
  },
});

export const actionLabels: Record<ACTION_TYPE, string> = {
  ask_ai: t('ask_ai'),
  ask_ai_agent: t('ask_ai_agent'),
  combo_send_form: t('combo_send_form'),
  code: t('code'),
  condition: t('condition'),
  condition_v2: t('condition_v2'),
  convert_document: t('convert_document'),
  create_document: t('create_document'),
  calendar_event: t('calendar_event'),
  ghost: t('ghost'),
  branch_base: t('branch_base'),
  integration: t('integration'),
  webhook: t('webhook'),
  journey_branch: t('journey_branch'),
  journey_merge: t('journey_merge'),
  journey_start: t('journey_start'),
  journey_triggers: t('journey_triggers'),
  placeholder: t('placeholder'),
  formatter: t('formatter'),
  send_email: t('send_email'),
  send_sms: t('send_sms'),
  journey_loop: t('journey_loop'),
  break_loop: t('break_loop'),
  wait_for_time: t('wait_for_time'),
  wait_for_attribute_change: t('wait_for_attribute_change'),
  wait_until_fixed_date: t('wait_until_fixed_date'),
  wait_until_relative_date: t('wait_until_relative_date'),
  update_fields: t('update_fields'),
  add_to_journey: t('add_to_journey'),
  update_traveller: t('update_traveller'),
  anonymize_text: t('anonymize_text'),
  extract_text: t('extract_text'),

  // Should most likely not be used
  hidden: t('hidden'),
  instantiate_form: t('instantiate_form'),
};
